module.exports = __webpack_public_path__ + "static/media/sui-generis-rg.403eb93f.otf";